import { pendoTrack, updatePendoMetadata } from 'common/util/functions'

export interface UTMParams {
    utm_source?: string
    utm_medium?: string
    utm_campaign?: string
    utm_term?: string
    utm_content?: string
}

export type ActionContext = 'dashboard' | 'minutes' | 'notification' | 'search' | 'report'

export const addUTMParams = (url: URL, utmParams: UTMParams): void => {
    Object.entries(utmParams).forEach(([key, value]) => {
        if (value && value.trim() !== '') {
            url.searchParams.set(key, value)
        }
    })
}
export const getActionDeepLinkUTMs = (context: ActionContext, actionId?: string): UTMParams => {
    const baseUTMs: UTMParams = {
        utm_source: 'minutes_app',
        utm_medium: 'deep_link',
        utm_campaign: 'action_access'
    }

    const contextMap: Record<ActionContext, string> = {
        dashboard: 'action_dashboard',
        minutes: 'action_minutes',
        notification: 'action_notification',
        search: 'action_search',
        report: 'action_report'
    }

    return {
        ...baseUTMs,
        utm_content: contextMap[context],
        ...(actionId && { utm_term: actionId })
    }
}

export const createActionDeepLinkWithUTMs = (
    baseUrl: string,
    actionId: string,
    context: ActionContext,
    additionalParams?: Record<string, string>
): string => {
    const url = new URL(baseUrl)

    url.searchParams.set('action', actionId)

    const utmParams = getActionDeepLinkUTMs(context, actionId)
    addUTMParams(url, utmParams)

    if (additionalParams) {
        Object.entries(additionalParams).forEach(([key, value]) => {
            if (value) {
                url.searchParams.set(key, value)
            }
        })
    }

    return url.toString()
}

export const extractUTMParams = (url?: string): UTMParams => {
    const urlToCheck = url || window.location.href
    const urlObj = new URL(urlToCheck)

    return {
        utm_source: urlObj.searchParams.get('utm_source') || undefined,
        utm_medium: urlObj.searchParams.get('utm_medium') || undefined,
        utm_campaign: urlObj.searchParams.get('utm_campaign') || undefined,
        utm_term: urlObj.searchParams.get('utm_term') || undefined,
        utm_content: urlObj.searchParams.get('utm_content') || undefined
    }
}
export const logActionDeepLinkAccess = (context: string, actionId: string): void => {
    const utmParams = extractUTMParams()

    if (!utmParams.utm_source) {
        return
    }
    try {
        pendoTrack('utm_action_deep_link_clicked', {
            utm_source: utmParams.utm_source,
            utm_medium: utmParams.utm_medium,
            utm_campaign: utmParams.utm_campaign,
            utm_content: utmParams.utm_content,
            utm_term: utmParams.utm_term,
            action_id: actionId,
            context: context,
            timestamp: new Date().toISOString()
        })
    } catch (error) {
        console.warn('Failed to send track event:', error)
    }
    try {
        updatePendoMetadata(
            {
                utm_source: utmParams.utm_source,
                utm_medium: utmParams.utm_medium,
                utm_campaign: utmParams.utm_campaign,
                utm_content: utmParams.utm_content,
                utm_term: utmParams.utm_term,
                last_utm_action_id: actionId,
                last_utm_context: context,
                last_utm_timestamp: new Date().toISOString()
            },
            true
        )
    } catch (error) {
        console.warn('Failed to update Pendo metadata:', error)
    }
}

export const removeUTMParams = (url: URL, includeActionParam: boolean = true): void => {
    url.searchParams.delete('utm_source')
    url.searchParams.delete('utm_medium')
    url.searchParams.delete('utm_campaign')
    url.searchParams.delete('utm_content')
    url.searchParams.delete('utm_term')

    if (includeActionParam) {
        url.searchParams.delete('action')
    }
}

export const handleActionTabNavigation = (history: any): boolean => {
    const url = new URL(window.location.href)
    const isActionTab = url.searchParams.get('tab') === 'minutes-actions'

    if (isActionTab) {
        removeUTMParams(url)
        window.history.replaceState(null, '', url.toString())
        return true
    } else {
        history.push('/actionDashboard')
        return false
    }
}
